<template>
  <div id="scContainer">
    <div :style="{color: vColor}" id="scText">{{text}}
    </div>
    <div id="scCM" class="checkmark_container" v-bind:class="{ show_checkmark: valid }">
      <svg width="80%" height="80%" viewBox="0 0 140 100">
        <path class="checkmark"
              v-bind:class="{ checked: valid }"
              d="M10,50 l25,40 l95,-70" />
      </svg>
    </div>
    <div id="xcCM" class="checkmarkX_container" v-bind:class="{ show_checkmark: !valid }">
    </div>
  </div>
</template>

<script>
export default {
  name: 'showCheck',
  props: ['text', 'valid'],
  data() {
    return {
      //
    };
  },
  computed: {
    vColor() {
      if (this.valid === true) {
        return 'green';
      }
      return 'red';
    },
  },
};
</script>

<style scoped>
  #scContainer {
    position: relative;
    height: 30px;
    width: 250px;
    margin: auto;
    /* border: solid 1px blue; */
  }
  #scText {
    position: absolute;
    top: 2px; left: 30px;
  }
  #scCM {
    position: absolute;
    top: 2px; left: 1px;
    z-index: 1;
  }
  #xcCM {
    position: absolute;
    top: 2px; left: 1px;
    z-index: 0;
  }
  .checkmark_container {
    border-radius: 30%;
    /* background: #2ecc71; */
    border: solid 2px green;
    width: 20px; height: 20px;
    visibility: hidden;
    opacity: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity .4s ease;
  }
  .checkmark {
    width: 100%;
    height: 100%;
    fill: none;
    stroke: black;
    stroke-width: 15;
    stroke-linecap: round;
    stroke-dasharray: 180;
    stroke-dashoffset: 180;
  }
  .checkmarkX_container {
    border-radius: 30%;
    border: solid 2px red;
    /* background: #FF8080; */
    width: 20px; height: 20px;
    visibility: hidden;
    opacity: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity .4s ease;
  }
  .show_checkmark {
    visibility: visible;
    opacity: 1;
  }
  .checked { animation: draw 0.5s ease forwards; }

  @keyframes draw {
    to { stroke-dashoffset: 0; }
  }
</style>



// WEBPACK FOOTER //
// src/components/roCheck.vue